<template>
  <main id="shuttle-file-main">
    <warehouse-list :action-str-mount-chained="actionMountChained" :action-str-select-chained="actionSelectChained" />
    <div class="app-view-container">
      <el-row>
        <el-col class="app-view-title">
          {{ $t('routing.shuttleFile.title') }}
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <search-filter ref="searchFilter" />
        </el-col>
      </el-row>

      <el-row class="search-summary-container bg-white">
        <el-col>
          <el-row class="default-section-header">
            <el-col :span="6" class="default-section-title">
              {{ $t('routing.shuttleFile.summary') }}
              <el-tooltip class="item" effect="dark" :enterable="false" :content="$t('common.refresh')" placement="top-start">
                <el-button @click="handleRefresh" icon="el-icon-refresh" size="mini" class="button-action-default search-summary-refresh-button"></el-button>
              </el-tooltip>
            </el-col>
            <el-col :span="18" class="default-section-actions text-align-end">
              <generate-shuttle-file />
              <update-all-shuttle-file />
              <add-shuttle-file/>
            </el-col>
          </el-row>
          <el-row class="search-summary">
            <el-col>
              <search-summary />
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
  </main>
</template>

<script>
import WarehouseList from '@/components/WarehouseList/WarehouseList';
import { SHUTTLE_FILE_SEARCH } from '@/store/actions';
import SearchFilter from './SearchFilter';
import SearchSummary from './SearchSummary';
import AddShuttleFile from './components/AddShuttleFile';
import UpdateAllShuttleFile from './components/UpdateAllShuttleFile';
import GenerateShuttleFile from './components/GenerateShuttleFile';

export default {
  name: 'ShuttleFile',
  components: {
    SearchFilter,
    SearchSummary,
    WarehouseList,
    AddShuttleFile,
    UpdateAllShuttleFile,
    GenerateShuttleFile
  },
  data() {
    return {
      actionMountChained: ['shuttleFile/setDefaultFilters'],
      actionSelectChained: [SHUTTLE_FILE_SEARCH]
    };
  },
  methods: {
    handleRefresh() {
      this.$refs.searchFilter.handleSearch();
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">
#shuttle-file-main {
  .default-section-title {
    padding-top: 10px;
    padding-bottom: 10px;
  }
}
</style>
